import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { ThemeProvider } from './context/ThemeContext'
import { MusicProvider } from './context/MusicContext'
import AppRouter from './router/AppRouter'

function App() {
  return (
    <ThemeProvider>
      <Router
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <MusicProvider>
          <AppRouter />
        </MusicProvider>
      </Router>
    </ThemeProvider>
  )
}

export default App
